import api from '@/services/api';

const ENTITY_ENDPOINT = 'proceso';
const ETIQUETAS_ENDPOINT = 'procesos-etiquetas';

const proceso_service = {
  /**
   * Obtiene todos los procesos con parámetros de paginación y filtros
   * @param {Object} queryParams - Parámetros de consulta
   * @returns {Promise} Respuesta de la API
   */
  async findAll(queryParams = {}) {
    try {
      const params = new URLSearchParams({
        ...queryParams,
        page: queryParams.page !== undefined && queryParams.page !== null ? queryParams.page : 1,
        sortBy: queryParams.sortBy || 'Descripcion',
        sort: queryParams.sort || 'asc',
        Activo: queryParams.Activo !== undefined ? queryParams.Activo : true,
      }).toString();

      const response = await api.get(`/${ENTITY_ENDPOINT}?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error finding all procesos:', error);
      throw error;
    }
  },

  /**
   * Obtiene todos los procesos etiquetas con paginación
   * @param {number} page - Número de página
   * @returns {Promise} Respuesta de la API
   */
  async findAllEtiquetas(page = 1) {
    try {
      const response = await api.get(`/${ETIQUETAS_ENDPOINT}`, {
        params: { page: +page },
      });
      return response;
    } catch (error) {
      console.error('Error finding all procesos etiquetas:', error);
      throw error;
    }
  },

  /**
   * Busca procesos por descripción
   * @param {string} query - Texto de búsqueda para la descripción
   * @param {number} page - Número de página (opcional)
   * @returns {Promise} Respuesta de la API
   */
  async searchByDescription(query, page = 1) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/description`, {
        params: {
          Descripcion: query,
          page,
        },
      });
      return response;
    } catch (error) {
      console.error(`Error searching procesos by description '${query}':`, error);
      throw error;
    }
  },

  /**
   * Busca un proceso por su código
   * @param {string} codigo - Código del proceso
   * @returns {Promise} Respuesta de la API
   */
  async findByCodigo(codigo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error finding proceso with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Crea un nuevo proceso
   * @param {Object} data - Datos del proceso a crear
   * @returns {Promise} Respuesta de la API
   */
  async create(data) {
    try {
      const response = await api.post(`/${ENTITY_ENDPOINT}`, data);
      return response;
    } catch (error) {
      console.error('Error creating proceso:', error);
      throw error;
    }
  },

  /**
   * Actualiza un proceso existente
   * @param {string} codigo - Código del proceso a actualizar
   * @param {Object} data - Datos actualizados del proceso
   * @returns {Promise} Respuesta de la API
   */
  async update(codigo, data) {
    try {
      const response = await api.put(`/${ENTITY_ENDPOINT}/${codigo}`, data);
      return response;
    } catch (error) {
      console.error(`Error updating proceso with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Elimina un proceso
   * @param {string} codigo - Código del proceso a eliminar
   * @returns {Promise} Respuesta de la API
   */
  async delete(codigo) {
    try {
      const response = await api.delete(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error deleting proceso with codigo ${codigo}:`, error);
      throw error;
    }
  },

  async findRecursosByProceso(codigo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigo}/recursos`);
      return response;
    } catch (error) {
      console.error(`Error finding recursos for proceso with codigo ${codigo}:`, error);
      throw error;
    }
  },
};

export default proceso_service;
